module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab17/awsop-lab17.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab17/awsop-lab17.component.css
// module chunks = main